import { PropsWithChildren, createContext, useContext } from 'react';

import useNoteAttachmentModal, {
  NoteState,
} from '../hooks/useNoteAttachmentModal';

export const NoteAttachmentModalContext = createContext<NoteState | undefined>(
  undefined,
);

const NoteAttachmentModalContextProvider = ({
  children,
}: PropsWithChildren) => {
  const value = useNoteAttachmentModal();

  return (
    <NoteAttachmentModalContext.Provider value={value}>
      {children}
    </NoteAttachmentModalContext.Provider>
  );
};

const useNoteAttachmentModalContext = (): NoteState => {
  const context = useContext(NoteAttachmentModalContext);

  if (context === undefined) {
    throw new Error(
      'useNoteAttachmentModalContext must be used within a NoteAttachmentModalContextProvider',
    );
  }

  return context;
};

export { NoteAttachmentModalContextProvider, useNoteAttachmentModalContext };
